module.exports = __webpack_public_path__ + "img/logo-ap-white.b512a684.png";